import { useEffect, useState } from "react";
var PAYMENT_MODE_CODE_MAP = {
    ANU: "ANNUAL",
    MON: "MONTHLY",
    SEM: "SEMIANNUAL",
    TRI: "QUARTERLY",
};
var mapPaymentModeCode = function (code) { var _a; return (_a = PAYMENT_MODE_CODE_MAP[code]) !== null && _a !== void 0 ? _a : code; };
export var usePaymentModeData = function (responsePaymentMode) {
    var _a = useState([]), listModalidadPago = _a[0], setListModalidadPago = _a[1];
    useEffect(function () {
        var _a;
        if (responsePaymentMode && responsePaymentMode.data) {
            var data = responsePaymentMode;
            var mapped = (_a = data.data) === null || _a === void 0 ? void 0 : _a.map(function (x, index) {
                var _a, _b, _c;
                return ({
                    id: (_a = x.catalogPaymentMode.id) !== null && _a !== void 0 ? _a : "",
                    name: (_b = x.catalogPaymentMode.description) !== null && _b !== void 0 ? _b : "",
                    value: mapPaymentModeCode((_c = x.catalogPaymentMode.code) !== null && _c !== void 0 ? _c : ""),
                    active: false,
                });
            });
            setListModalidadPago(mapped || []);
        }
    }, [responsePaymentMode]);
    return { listModalidadPago: listModalidadPago };
};
